/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { HSMSafenetClientInfo } from 'object-types';
import { IHSMSafenetClientInfo } from 'generated-types';

/**
 * @description HSM Safenet ClientInfo Message Item.
 * @author vgohil
 */
export class HSMSafenetClientInfoConfigItem extends MessageItem<IHSMSafenetClientInfo> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HSMSafenetClientInfo,
            ...args,
        };

        super(extendedArgs);
    }
}
